import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/shared/components/ui/select";
import type { LinkedVariableOption } from "@/domains/templates/types";

/** Options are explicitly scoped by the owner; this field never fetches a broader catalog. */
export function TemplateVariableReferenceField({
  label,
  value,
  options,
  onChange,
  disabled = false,
}: {
  label: string;
  value: string;
  options: readonly LinkedVariableOption[];
  onChange: (id: string) => void;
  disabled?: boolean;
}) {
  const missing = !!value && !options.some((option) => option.id === value);
  return (
    <div className="space-y-1">
      <p className="text-sm font-medium">{label}</p>
      <Select value={value} onValueChange={onChange} disabled={disabled}>
        <SelectTrigger aria-label={label} aria-invalid={missing}>
          <SelectValue placeholder={`Select ${label.toLowerCase()}`}>
            {missing
              ? "Missing reference"
              : options.find((option) => option.id === value)?.name}
          </SelectValue>
        </SelectTrigger>
        <SelectContent>
          {options.map((option) => (
            <SelectItem key={option.id} value={option.id}>
              {option.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {missing && (
        <p role="alert" className="text-sm text-destructive">
          The selected reference is unavailable or incompatible. Select an
          available reference.
        </p>
      )}
    </div>
  );
}
